import { z } from "zod";

export const TestControllerResponseSchema = {
  echoTest: z.string(),
};
